const SocialShare = () => {
    return (
        <>
            <li>
                <a className="facebook" href="https://www.facebook.com/" target="_blank">
                    <i className="fab fa-facebook-f"></i>
                </a>
            </li>
            <li>
                <a className="twitter" href="https://twitter.com/" target="_blank">
                    <i className="fab fa-twitter"></i>
                </a>
            </li>
            <li>
                <a className="pinterest" href="https://www.pinterest.com/" target="_blank">
                    <i className="fab fa-pinterest-p"></i>
                </a>
            </li>
            <li>
                <a className="linkedin" href="https://www.linkedin.com/" target="_blank">
                    <i className="fab fa-linkedin-in"></i>
                </a>
            </li>
        </>
    );
};

export default SocialShare;